import React, { FC } from 'react';
import styles from './skills.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

const skillIcons = [
  { name: 'React', iconValue: icon({ name: 'react', style: 'brands' }) },
  { name: 'TypeScript', iconValue: icon({ name: 'code', style: 'solid' }) },
  { name: 'JavaScript', iconValue: icon({ name: 'js', style: 'brands' }) },
  { name: 'Node.js', iconValue: icon({ name: 'node-js', style: 'brands' }) },

  { name: 'Redux Toolkit', iconValue: icon({ name: 'layer-group', style: 'solid' }) },
  { name: 'Zod', iconValue: icon({ name: 'shield-halved', style: 'solid' }) },
  { name: 'REST / GraphQL', iconValue: icon({ name: 'server', style: 'solid' }) },
  { name: 'Frontend Architecture', iconValue: icon({ name: 'sitemap', style: 'solid' }) },
  { name: 'CI/CD', iconValue: icon({ name: 'code-branch', style: 'solid' }) },
  { name: 'Git', iconValue: icon({ name: 'git', style: 'brands' }) },

  { name: 'Testing', iconValue: icon({ name: 'vial', style: 'solid' }) },
  { name: 'Observability', iconValue: icon({ name: 'chart-line', style: 'solid' }) },
  { name: 'Stripe', iconValue: icon({ name: 'credit-card', style: 'solid' }) },
];

const Skills: FC = () => {
  return (
    <section id="skills" className={styles.skills}>
      <div className={styles.row}>
        <h2>Core Skills</h2>
        <p className={styles.description}>
          A practical stack focused on frontend excellence, team collaboration, and scalable product delivery.
        </p>

        <div className={styles.grid}>
          {skillIcons.map(item => (
            <div key={item.name} className={styles.card}>
              <FontAwesomeIcon icon={item.iconValue} size="3x" color="#1f4f72" />
              <span>{item.name}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
